<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
  <span class="icon"><i class="fas fa-print" aria-hidden="true"></i></span>{{ 'AutoPrintSetting.Header' | translate }}
  </h1>
  <laas-auto-print-setting-header [facilityOptions]="facilityOptions"></laas-auto-print-setting-header>

  <laas-auto-print-setting-detail [facilityOptions]="facilityOptions"></laas-auto-print-setting-detail>

  <laas-facility-printer [facilityCodeOptions]="facilityOptions"></laas-facility-printer>

</div>

<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
